import apiClient from './apiClient';

export interface CreateAppointmentRequest {
    appointmentDate: string;
    appointmentTime: string; // HH:mm format
    userId: string;
    residentId: string;
    reason: string;
    appointmentType: string;
    hospitalName?: string;
    facilityId: string;
    doctorId?: string;
    doctorName?: string;
    includeInBilling?: boolean;
    isTransportationScheduled?: boolean;
    mobilityType?: string;
    vendor?: string;
    transportContactNumber?: string;
}

class AppointmentService {
    private BASE_PATH = '/v1/appointments';

    /**
     * Create a new medical appointment
     */
    async createAppointment(request: CreateAppointmentRequest): Promise<any> {
        const response = await apiClient.post(this.BASE_PATH, request);
        return response.data;
    }

    /**
     * Get list of doctors
     */
    async getDoctors(): Promise<any[]> {
        const response = await apiClient.get(`${this.BASE_PATH}/doctors`);
        return response.data;
    }

    /**
     * Get appointments by resident ID
     */
    async getAppointments(residentId: string, facilityId?: string): Promise<any[]> {
        let url = `${this.BASE_PATH}/resident/${residentId}`;
        if (facilityId) {
            url += `?facilityId=${facilityId}`;
        }
        const response = await apiClient.get(url);
        return response.data;
    }

    /**
     * Update an existing appointment
     */
    async updateAppointment(id: string, request: CreateAppointmentRequest): Promise<any> {
        const response = await apiClient.put(`${this.BASE_PATH}/${id}`, request);
        return response.data;
    }

    /**
     * Delete an appointment
     */
    async deleteAppointment(id: string): Promise<void> {
        await apiClient.delete(`${this.BASE_PATH}/${id}`);
    }

    /**
     * Get appointments for today
     */
    async getTodayAppointments(facilityId: string): Promise<any[]> {
        const response = await apiClient.get(`${this.BASE_PATH}/today?facilityId=${facilityId}`);
        return response.data;
    }
}

export default new AppointmentService();
